import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AosVue from 'aos-vue'

createApp(App).use(router).use(AosVue).use(VueAxios, axios).mount('#app')
